import React from 'react';
import PropTypes from 'prop-types';
import Button from '../base/Button/GlyphedButton';

const LeftRightButtonsPanel = ({leftButtonGlyph, leftButtonLabel, leftButtonName, leftButtonOnClick, rightButtonGlyph, rightButtonIsDisabled, rightButtonLabel, rightButtonName, rightButtonOnClick}) => {
    return(
        <div className="col-xs-12">
            <Button
                floated="left"
                glyphComponent={leftButtonGlyph}
                id={leftButtonName}
                name={leftButtonName}
                onClick={leftButtonOnClick}
                label={leftButtonLabel} />
            <Button
                disabled={rightButtonIsDisabled}
                floated="right"
                glyphComponent={rightButtonGlyph}
                id={rightButtonName}
                name={rightButtonName}
                onClick={rightButtonOnClick}
                label={rightButtonLabel} />
        </div>
    );
};

LeftRightButtonsPanel.propTypes = {
    //Left button glyph component.
    leftButtonGlyph: PropTypes.node,
    //Left button label.
    leftButtonLabel: PropTypes.string,
    //Left button name and id.
    leftButtonName: PropTypes.string,
    //On left button click function handler.
    leftButtonOnClick: PropTypes.func,
    //Right button glyph component.
    rightButtonGlyph: PropTypes.node,
    //Right button disable value.
    rightButtonIsDisabled: PropTypes.bool,
    //Right button label.
    rightButtonLabel: PropTypes.string,
    //Right button name and id.
    rightButtonName: PropTypes.string,
    //On right button click function handler.
    rightButtonOnClick: PropTypes.func,
};

export default LeftRightButtonsPanel;


// WEBPACK FOOTER //
// ./src/components/Buttons/LeftRightButtonsPanel.js